// The API lives at /api on whichever address serves the site. When the site is opened on a custom
// domain (e.g. tantrictemple.au) we call that same domain, so sign-in cookies stay first-party.
const configured = process.env.REACT_APP_BACKEND_URL;

const sameSite = () => {
  try {
    return window.location.origin !== new URL(configured).origin && window.location.protocol === "https:";
  } catch {
    return false;
  }
};

export const API_BASE = configured ? `${sameSite() ? window.location.origin : configured}/api` : null;
